import React, { useState, useCallback, useEffect } from 'react';
import FileUpload from './components/FileUpload';
import DataView from './components/DataView';
import './App.css';

function App() {
  const [data, setData] = useState(null);
  const [columns, setColumns] = useState([]);
  const [fileName, setFileName] = useState('');

  // Load from localStorage on mount
  useEffect(() => {
    try {
      const savedData = localStorage.getItem('excelData');
      const savedColumns = localStorage.getItem('excelColumns');
      const savedFileName = localStorage.getItem('excelFileName');
      
      if (savedData && savedColumns) {
        const parsedData = JSON.parse(savedData);
        const parsedColumns = JSON.parse(savedColumns);
        if (parsedData.length > 0 && parsedColumns.length > 0) {
          setData(parsedData);
          setColumns(parsedColumns);
          setFileName(savedFileName || 'Dosya');
        }
      }
    } catch (e) {
      console.error('LocalStorage verisi okunamadı:', e);
    }
  }, []);

  const handleDataLoaded = useCallback((newData, newColumns, newFileName) => {
    setData(newData);
    setColumns(newColumns);
    setFileName(newFileName);
  }, []);

  const handleReset = useCallback(() => {
    setData(null);
    setColumns([]);
    setFileName('');
  }, []);

  if (!data || data.length === 0) {
    return <FileUpload onDataLoaded={handleDataLoaded} />;
  }

  return (
    <DataView
      data={data}
      columns={columns}
      fileName={fileName}
      onReset={handleReset}
    />
  );
}

export default App;
